import { queryOptions } from "@tanstack/react-query";
import { analyticsApi } from "./api";
import type { AnalyticsParams } from "./types";

export const analyticsKeys = {
  all: ["analytics"] as const,
  detail: (shortCode: string, params: AnalyticsParams = {}) =>
    [...analyticsKeys.all, shortCode, params] as const,
};

export function analyticsOptions(shortCode: string, params: AnalyticsParams = {}) {
  return queryOptions({
    queryKey: analyticsKeys.detail(shortCode, params),
    queryFn: () => analyticsApi.get(shortCode, params),
    enabled: !!shortCode,
  });
}
